/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { NOT_FOUND } from '@jira/platform__http-status-codes/src/http-status-codes.tsx';
import {
	performPutRequest,
	performDeleteRequest,
	performGetRequest,
} from '@atlassian/jira-fetch/src/utils/requests.tsx';

const url = (key: string) => `/rest/api/3/mypreferences?key=${key}`;

const get = async <T = string,>(key: string): Promise<T | null> => {
	try {
		const result = await performGetRequest(url(key));
		return result?.value;
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		if (error.statusCode === NOT_FOUND) {
			return null;
		}
		throw error;
	}
};

const set = <T = string,>(key: string, value: T): Promise<void> =>
	performPutRequest(url(key), { body: JSON.stringify({ value }) });

const remove = (key: string): Promise<void> => performDeleteRequest(url(key));

export const userPreferenceAPI: {
	get: <T = string>(key: string) => Promise<T | null>;
	set: <T = string>(key: string, value: T) => Promise<void>;
	remove: (key: string) => Promise<void>;
} = {
	get,
	set,
	remove,
};
